
import { Component } from '@angular/core';
import { ScorecardComponent } from '../../components/scorecard/scorecard.component';

@Component({
  selector: 'app-scorecard-verify',
  imports: [ScorecardComponent],
  templateUrl: './scorecard-verify.component.html',
  styleUrl: './scorecard-verify.component.scss'
})
export class ScorecardVerifyComponent {
}
